export default {
  'usermenu.dialog.title': '信息',
  'usermenu.dialog.content': '您确定要注销吗？',
  'userLayout.title': 'Ant Design 是西湖区最具影响力的 Web 设计规范',
}
